import React from 'react'
import { Input } from 'antd'
import { BigOrder } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { SearchOutlined } from '@ant-design/icons'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import {
  filterOrderTextSelector,
  setFilterOrderText,
  orderListSelector,
  setFilteredOrders,
} from 'src/features'

const FilterOrderInput = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const filterText = useAppSelector(filterOrderTextSelector)
  const orderList = useAppSelector(orderListSelector)

  const handleChange = (event: any) => {
    const value = event.target.value
    dispatch(setFilterOrderText(value))
    const newOrderList: BigOrder[] = getNewDepositsFiltered(value)
    dispatch(setFilteredOrders(newOrderList))
  }

  const getNewDepositsFiltered = (searchText: string) => {
    const text = searchText?.toLowerCase()
    if ([text === undefined, text === null, text?.trim()?.length === 0].includes(true)) return orderList
    return orderList.filter((p: BigOrder)=> {
      return (
        p.order.reference.toLowerCase().includes(searchText) ||
        p.order_items.find((x) => x.project_name.toLocaleLowerCase().includes(searchText))
      )
    })
  }

  return (
    <Input
      onChange={handleChange}
      value={filterText}
      placeholder={t('Transactions.FilterOrder')}
      prefix={<SearchOutlined className='site-form-item-icon' />}
      allowClear
    />
  )
}

export default FilterOrderInput
